import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
import { WorkspacePermissionsFragmentDoc } from '../../fragments/generated/WorkspacePermissions';
import { OngoingTimerFragmentDoc } from '../../../../tasks/views/TasksDashboard/components/TaskDashboard/TimerMenu/graphql/queries/generated/timeLogs';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserProfileQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type UserProfileQuery = { user?: { emailId?: string | null, isManager: boolean, alias?: string | null, isStaff: boolean, status: Types.UserStatusEnum, meta?: string | null, timezone?: string | null, federationId?: string | null, currentSubWorkspace?: string | null, suggestedQuestionForCoach: Array<string>, id: string, name?: string | null, firstName?: string | null, uniqueId: string, profilePicture?: string | null, workspacePermissions: Array<{ action: Types.WorkspaceActions, subject: Types.WorkspaceSubjects }>, preferences?: { showMarketplaceContentCatalogBanner?: boolean | null } | null, ongoingTimer?: { startTime: string, endTime?: string | null, userId: string, entityId: string, entityType: Types.TimeLogEntityTypeEnum, parentEntityId?: string | null, parentEntityType?: Types.TimeLogEntityTypeEnum | null, id: string } | null, orgRole?: { id: string, name: string } | null } | null };


export const UserProfileDocument = /*#__PURE__*/ gql`
    query UserProfile($userId: String!) {
  user(filters: {userId: $userId}) {
    ...User
    emailId
    isManager
    alias
    isStaff
    status
    meta
    timezone
    federationId
    workspacePermissions {
      ...WorkspacePermissions
    }
    currentSubWorkspace
    preferences {
      showMarketplaceContentCatalogBanner
    }
    suggestedQuestionForCoach
    ongoingTimer {
      ...OngoingTimer
    }
  }
}
    ${UserFragmentDoc}
${WorkspacePermissionsFragmentDoc}
${OngoingTimerFragmentDoc}`;

export function useUserProfileQuery(options: Omit<Urql.UseQueryArgs<UserProfileQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfileQuery, UserProfileQueryVariables>({ query: UserProfileDocument, ...options });
};